module.exports = __webpack_public_path__ + "static/media/acrobat-pro-cc.5c522a38.svg";